(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maintenance-guide"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const parent = document.querySelector('.mg-page-container');
    if (!parent) return;

    const videoEl = document.getElementById('mg-main-video');
    const playToggle = document.getElementById('mg-play-toggle');
    const muteToggle = document.getElementById('mg-mute-toggle');
    const streamProgress = document.getElementById('mg-stream-progress');
    const liveDot = document.getElementById('mg-live-dot');
    const equalizer = document.getElementById('mg-eq');

    const liveLabel = document.getElementById('mg-live-label');
    const speakerLabel = document.getElementById('mg-speaker-label');
    const captionBody = document.getElementById('mg-caption-body');

    const summaryStep = document.getElementById('mg-summary-step');
    const summaryTitle = document.getElementById('mg-summary-title');
    const summaryDesc = document.getElementById('mg-summary-desc');
    const summaryTime = document.getElementById('mg-summary-time');
    const summaryAdvisory = document.getElementById('mg-summary-advisory');
    const summaryBullets = document.getElementById('mg-summary-bullets');
    const productTargetLink = document.getElementById('mg-product-target-link');

    const videoTabButtons = document.querySelectorAll('.mg-video-tab-btn');
    const sidebarLinks = document.querySelectorAll('.mg-sb-link');
    const chapters = document.querySelectorAll('.mg-chapter-card');

    let currentStep = 0;

    const dataSteps = [
      {
        videoSrc: 'https://assets.mixkit.co/videos/preview/mixkit-washing-hair-in-a-salon-shampoo-bowl-43093-large.mp4',
        poster: 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?q=80&w=1200',
        liveLabel: 'LIVE DEMO • STEP 1',
        speaker: 'SPEAKER: Dr. Chandrashekar, Trichologist',
        caption:
          'Our Reset Scalp Cleanser uses plant-derived dermo-purifiers. Massaging it gently allows salicylic micro-molecules to break up heavy tape residues without burning skin.',
        stepLbl: 'Step 01 / RESET',
        title: 'Scalp Cleanser & Base Prep',
        desc: 'Specially formulated to separate residue bonds daily without degrading the live skin moisture layers or human follicle cells underneath.',
        time: '3 Minutes',
        advisory: 'Massage directly across the hairline. Do not pull the backing grid while dry.',
        bullets: [
          'Separates adhesive polymers safely',
          'Controls sweat odor & yeast scalp buildup',
          'Replenishes natural dermal lipids',
        ],
        prodSourceId: 'raw-html-shampoo',
      },
      {
        videoSrc:
          'https://assets.mixkit.co/videos/preview/mixkit-applying-hair-conditioner-on-a-woman-in-a-salon-43094-large.mp4',
        poster: 'https://images.unsplash.com/photo-1527613426441-4da17471b66d?q=80&w=1200',
        liveLabel: 'LIVE DEMO • STEP 2',
        speaker: 'SPEAKER: Nitesh, Co-Founder',
        caption:
          'The Renewal Anti-Shedding mask rebuilds cuticle layers instantly. Massage deep into mid-lengths and rinse cool to optimize hair system bounce and structure.',
        stepLbl: 'Step 02 / RENEWAL',
        title: 'Anti-Shedding Mask',
        desc: 'Formulated with France-stabilized Alariane Seaweed Shield and cationic lipids to rejuvenate dry hair system fibers under high humidity.',
        time: '5-10 Minutes',
        advisory: 'Rinse thoroughly with cold locks water. Prevent residue buildup on backing grid.',
        bullets: [
          'Reconstructs dry wig cuticles instantly',
          'Restores natural branch fiber flexibility',
          'Maintains 100% tape adhesive safety',
        ],
        prodSourceId: 'raw-html-infusion',
      },
      {
        videoSrc:
          'https://assets.mixkit.co/videos/preview/mixkit-spraying-water-on-hair-with-a-spray-bottle-43105-large.mp4',
        poster: 'https://images.unsplash.com/photo-1608248597481-496100c8c836?q=80&w=1200',
        liveLabel: 'LIVE DEMO • STEP 3',
        speaker: 'SPEAKER: Clinical Demonstration Team',
        caption:
          'Spray Refresh Mist daily morning before UV exposure. The fine Biotin particles shield hair strands from intense Indian humidity sweat without drenching tape borders.',
        stepLbl: 'Step 03 / REFRESH',
        title: 'Daily Leave-In Mist',
        desc: 'An absolute daily shield that prevents sweat odor, fights solar UV cuticle cracking, and keeps hair systems light and fresh.',
        time: 'Every Morning',
        advisory: 'Hold 6 inches away. Mist lightly over dry mid-lengths; do not drench tape joints.',
        bullets: [
          'Blocks solar UV cuticle erosion layers',
          'Keeps hair lightweight under humidity',
          'Detangles without static hair noise',
        ],
        prodSourceId: 'raw-html-hydra',
      },
    ];

    function syncStepUI(index) {
      currentStep = parseInt(index);
      const data = dataSteps[currentStep];

      document.querySelectorAll('.mg-tab-live-bar').forEach((b) => (b.style.width = '0%'));
      videoTabButtons.forEach((btn, idx) => {
        if (idx === currentStep) btn.classList.add('active');
        else btn.classList.remove('active');
      });

      videoEl.src = data.videoSrc;
      videoEl.poster = data.poster;

      liveLabel.textContent = data.liveLabel;
      speakerLabel.textContent = data.speaker;
      captionBody.textContent = `"${data.caption}"`;
      summaryStep.textContent = data.stepLbl;
      summaryTitle.textContent = data.title;
      summaryDesc.textContent = data.desc;
      summaryTime.textContent = data.time;
      summaryAdvisory.textContent = data.advisory;

      let bulletHtml = '';
      data.bullets.forEach((b) => {
        bulletHtml += `<div class="mg-bullet-entry"><svg fill="none" stroke="currentColor" stroke-width="3" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"/></svg><span>${b}</span></div>`;
      });
      summaryBullets.innerHTML = bulletHtml;

      // FIXED: Scoped these dynamic node lookups inside execution runtime safely
      const targetPayload = document.getElementById(data.prodSourceId);
      if (targetPayload && productTargetLink) {
        productTargetLink.innerHTML = targetPayload.innerHTML;
      } else {
        console.error('Payload source target mismatch for ID: ' + data.prodSourceId);
      }

      videoEl.play().catch(() => {});
      playToggle.classList.remove('is-paused');
      liveDot.classList.add('playing');
    }

    syncStepUI(0);

    videoTabButtons.forEach((button) => {
      button.addEventListener('click', function () {
        syncStepUI(this.getAttribute('data-step'));
      });
    });

    videoEl.addEventListener('timeupdate', function () {
      if (videoEl.duration) {
        const percentage = (videoEl.currentTime / videoEl.duration) * 100;
        streamProgress.style.width = percentage + '%';

        const currentActiveProgressTrack = document.getElementById(`live-progress-${currentStep}`);
        if (currentActiveProgressTrack) {
          currentActiveProgressTrack.style.width = percentage + '%';
        }
      }
    });

    videoEl.addEventListener('ended', function () {
      let nextStep = (currentStep + 1) % 3;
      syncStepUI(nextStep);
    });

    playToggle.addEventListener('click', function () {
      if (videoEl.paused) {
        videoEl.play();
        this.classList.remove('is-paused');
        liveDot.classList.add('playing');
      } else {
        videoEl.pause();
        this.classList.add('is-paused');
        liveDot.classList.remove('playing');
      }
    });

    muteToggle.addEventListener('click', function () {
      if (videoEl.muted) {
        videoEl.muted = false;
        this.classList.remove('is-muted');
        equalizer.classList.add('active');
      } else {
        videoEl.muted = true;
        this.classList.add('is-muted');
        equalizer.classList.remove('active');
      }
    });

    sidebarLinks.forEach((link) => {
      link.addEventListener('click', function () {
        const targetId = this.getAttribute('data-target');
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          const offsetTop = targetElement.getBoundingClientRect().top + window.scrollY - 110;
          window.scrollTo({ top: offsetTop, behavior: 'smooth' });

          sidebarLinks.forEach((l) => l.classList.remove('active'));
          this.classList.add('active');
        }
      });
    });

    // --- FIXED: Optimized ScrollSpy active Intersection Observer Configuration ---
    const observerOptions = {
      root: null,
      rootMargin: '-10% 0px -50% 0px', // Expanded trigger zone optimization loop window
      threshold: [0, 0.1, 0.2], // Multiple detection nodes prevent skipped tall section steps
    };

    const intersectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        // Check if section is visibly crossing active layout viewport paths
        if (entry.isIntersecting) {
          const activeId = entry.target.getAttribute('id');

          sidebarLinks.forEach((link) => {
            const linkTarget = link.getAttribute('data-target');

            if (linkTarget === activeId) {
              link.classList.add('active');
              // Smoothly scroll the sidebar track itself if menu elements overflow on mobile
              link.scrollIntoView({ block: 'nearest', inline: 'nearest' });
            } else {
              link.classList.remove('active');
            }
          });
        }
      });
    }, observerOptions);

    // Ensure sections are linked accurately to trigger engine loops
    chapters.forEach((ch) => {
      if (ch.getAttribute('id')) {
        intersectionObserver.observe(ch);
      }
    });

    // Backup manual click tracking block fallback sync
    sidebarLinks.forEach((link) => {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        const targetId = this.getAttribute('data-target');
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
          // Temporarily disconnect observer to prevent layout flash updates during rapid travel animations
          chapters.forEach((ch) => intersectionObserver.unobserve(ch));

          sidebarLinks.forEach((l) => l.classList.remove('active'));
          this.classList.add('active');

          const offsetTop = targetElement.getBoundingClientRect().top + window.scrollY - 100;
          window.scrollTo({ top: offsetTop, behavior: 'smooth' });

          // Re-engage engine tracking once traveling momentum completely stops
          setTimeout(() => {
            chapters.forEach((ch) => intersectionObserver.observe(ch));
          }, 800);
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
